import { dequal } from 'dequal/lite';
import { forwardRef, memo } from 'react';
import type { Behavior } from '#~/common/card/index.js';
import { Card as _Card } from '#~/video/components/card/index.js';
import type { Props } from '#~/video/components/card/index.js';

/** Memoized card component. */
export const Card = memo(
  forwardRef<Behavior, Props>((props, forwardedRef) => <_Card {...props} ref={forwardedRef} />),
  dequal
);
